import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Ruler = createSvgIcon(
  <path d="M23.979 6.375 17.625.022.021 17.625l6.354 6.354L23.979 6.375Zm-12.77 3.244 1.91-1.91L15 9.592 16.59 8l-1.88-1.881 2.915-2.916 3.172 3.172L6.375 20.797l-3.172-3.172L6.12 14.71 8 16.59 9.591 15 7.71 13.119l1.909-1.91L11 12.592 12.591 11 11.21 9.619Z" />,
  'Ruler'
);

export { Ruler };